import {PlanCodeItem} from 'ApplicationEntry/models/PlanCodes';
import {GroupAccident} from 'ApplicationEntry/models/ProductsRiders/Accident/GroupAccident';
import {NewYorkAccident} from 'ApplicationEntry/models/ProductsRiders/Accident/NewYorkAccident';
import {OrdinaryAccident} from 'ApplicationEntry/models/ProductsRiders/Accident/OrdinaryAccident';

export type Accident = OrdinaryAccident | GroupAccident | NewYorkAccident;

type ExhaustiveAccidentOptionsByType<TReturn> = {
  Ordinary: (ordinary: OrdinaryAccident) => TReturn;
  Group: (group: GroupAccident) => TReturn;
  NewYork: (newYork: NewYorkAccident) => TReturn;
};

type PartialAccidentOptionsByType<TReturn> = {
  Ordinary?: (ordinary: OrdinaryAccident) => TReturn;
  Group?: (group: GroupAccident) => TReturn;
  NewYork?: (newYork: NewYorkAccident) => TReturn;
  _: (app: Accident) => TReturn;
};

const isExhaustiveByType = <TReturn>(
  options: AccidentByTypeOptions<TReturn>
): options is ExhaustiveAccidentOptionsByType<TReturn> => !!options.Ordinary || (!!options.Group && !!options.NewYork);

type AccidentByTypeOptions<TReturn> = PartialAccidentOptionsByType<TReturn> | ExhaustiveAccidentOptionsByType<TReturn>;

export const matchAccidentByType = <TReturn>(options: AccidentByTypeOptions<TReturn>) => (app: Accident): TReturn => {
  switch (app.key) {
    case 'InvalidOrdinaryAccident':
    case 'ValidOrdinaryAccident':
      return isExhaustiveByType(options)
        ? options.Ordinary(app)
        : options.Ordinary
        ? options.Ordinary(app)
        : options._(app);
    case 'InvalidGroupAccident':
    case 'ValidGroupAccident':
      return isExhaustiveByType(options) ? options.Group(app) : options.Group ? options.Group(app) : options._(app);
    case 'InvalidNewYorkAccident':
    case 'ValidNewYorkAccident':
      return isExhaustiveByType(options)
        ? options.NewYork(app)
        : options.NewYork
        ? options.NewYork(app)
        : options._(app);
  }
};

export const isValidAccident = (accident: Accident) =>
  accident.key === 'ValidOrdinaryAccident' ||
  accident.key === 'ValidGroupAccident' ||
  accident.key === 'ValidNewYorkAccident';

type riderList = {
  code: string;
  units: number;
};

export const handleRidersInQuality = (planCodes: PlanCodeItem[]) => {
  const ridersList: riderList[] = [];
  planCodes.forEach((planCode, index) => {
    const riders = {} as riderList;
    if (index !== 0) {
      riders.code = planCode.tracInputL70;
      riders.units = planCode.units;

      ridersList.push(riders);
    }
  });

  return ridersList;
};
